import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import AboutHome from '../components/AboutHome';
import PopularProducts from '../components/PopularProducts';
import SpecialOfferProducts from '../components/SpecialOfferProducts';
import BlogsHome from '../components/BlogsHome';
import WhyChooseHome from '../components/WhyChooseHome';

import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import Slider from '../common/Slider';
import MobileMenu from '../common/MobileMenu';
import {api_base_url, base_url} from '../common/Constants';
 
class Home extends React.Component{

    constructor(){
        super();
        this.state = {
            categories : [],
            page_content:[],
            loading:1,
            banners:[]
        }
    }
    componentWillUpdate()
    {
        axios.get(api_base_url+"banners").then(response=>{
                
            this.setState({banners:response.data}) ; 
            
            
        });
    }componentWillMount()
        {
        axios.get(api_base_url+"banners").then(response=>{
                
            this.setState({banners:response.data}) ; 
            
            
        });
        axios.get(api_base_url+"categories").then(response=>{
            this.setState({categories:response.data});
            console.log("2");  
            console.log(this.state.banners);
            axios.get(api_base_url+"page_content").then(response=>{
                this.setState({page_content:response.data}); 
                console.log("3");
                console.log(this.state.banners);
                
            }); 
        }); 
    }

    componentDidMount()
    {
        axios.get(api_base_url+"banners").then(response=>{
                
            this.setState({banners:response.data}) ; 
            console.log("4"); 
            console.log(this.state.banners);
            
        });
    }


    render()
    {
        
        return (
<div>
            <div className="page-wrapper">
      <Header/> 

        <Slider banners={this.state.banners}/>
            <section className="gallery-page section-space">
            <div className="container">
                <div className="row gutter-y-20">
                 
                {this.state.categories.map((cat,key)=>{
                    return <div className="col-md-6 col-4 col-lg-2">
                      
                                                    <Link to={`/category/${cat.slug}`} className='cat-icon' style={{backgroundImage: `url(${cat.icon})`}}>  </Link>
                                                     
                                                
                                             </div> 
                 })}
  
                    </div>  
                </div> 
        </section>


        <AboutHome/>
        <SpecialOfferProducts/>
        <PopularProducts/>
        <WhyChooseHome />

        <BlogsHome/>
        <Footer/>
       

      <div className="custom-cursor__cursor"></div>
      <div className="custom-cursor__cursor-two"></div>
      </div>
       <MobileMenu/>
       </div>
      
       
        )
    }

}
export default Home;